import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LinkingRequest from "./pages/LinkingRequest";
import PeppolRegistration from "./pages/PeppolRegistration";
import NotFound from "./pages/NotFound";
import SessionTimeout from "./pages/SessionTimeout";
import ReverifyingOrDeLinkingRequest from "./pages/ReverifyOrDelinkingRequest";
import SuccessScreen from "./pages/VerificationSuccess";

import { MessageProvider } from "./components/ui/re-usable-message";

const queryClient = new QueryClient();

// Read query params safely
const params = new URLSearchParams(window.location.search);

// TIN exists => re-verification/de-link flow
const tin = params.get("TIN");

const App = () => (
  <QueryClientProvider client={queryClient}>
    <MessageProvider duration={3} maxCount={5} offset={24}>
      <TooltipProvider>
        <Toaster />
        <Sonner />

        {/* IMPORTANT FIX:
            Removed basename completely because app is hosted at root:
            https://uae-connect-uat.taxilla.com/
        */}
        <BrowserRouter>
          <Routes>

            {/* Home Route */}
            <Route
              path="/"
              element={
                tin
                  ? <ReverifyingOrDeLinkingRequest />
                  : <LinkingRequest />
              }
            />

            {/* Reverify / Delink */}
            <Route
              path="/re-verify-or-de-link-request"
              element={<ReverifyingOrDeLinkingRequest />}
            />

            {/* Registration */}
            <Route
              path="/peppol-registration"
              element={<PeppolRegistration />}
            />

            {/* Success */}
            <Route
              path="/success"
              element={<SuccessScreen />}
            />

            {/* Session Timeout */}
            <Route
              path="/session-timeout"
              element={<SessionTimeout />}
            />

            {/* 404 */}
            <Route
              path="*"
              element={<NotFound />}
            />

          </Routes>
        </BrowserRouter>

      </TooltipProvider>
    </MessageProvider>
  </QueryClientProvider>
);

export default App;